/**
 * Los nombres que el frontal necesita saber de la sesión.
 *
 * Están aquí porque los dos frontales tienen que usar exactamente los mismos:
 * si el portal y el panel discreparan en el nombre de la cookie del testigo,
 * uno de los dos dejaría de poder escribir nada y el fallo aparecería como un
 * 403 sin explicación, lejos de su causa.
 *
 * El servidor tiene su propia copia en `apps/api/src/contexto.ts`, y esa es la
 * autoridad: estas constantes solo tienen que coincidir con ella.
 */

/** Cookie del testigo anti-CSRF, legible por JavaScript a propósito (D-10, D-46). */
export const COOKIE_CSRF = '__Host-citas_csrf';

/** Cabecera en la que el frontal reenvía ese testigo. */
export const CABECERA_CSRF = 'x-csrf-token';
